import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AddButtonLink } from '@/core/components';

import { ReclaimableAuthorList } from '@feature/utils/components/ReclaimableAuthorList';

import { PatentReclaimSearch, ReclaimRequest } from './model/PatentTypes';

interface PatentFoundModalProps {
  close: () => void;
  data: PatentReclaimSearch;

  onReclaimAuthorship: (v: ReclaimRequest) => void;
}

export function PatentFoundModal({ close, data, onReclaimAuthorship }: PatentFoundModalProps) {
  const { patent } = data;
  const { t } = useTranslation();

  return (
    <Modal
      opened
      onClose={close}
      centered
      size="lg"
      title={patent != null && t('patents.foundPub')}
    >
      {patent == null && (
        <Stack>
          <Text ta="center">{t('publications.notSearchFound')}</Text>
          <AddButtonLink
            to="../create"
            name={t('button.addNew')}
          />
        </Stack>
      )}
      {patent != null && (
        <Stack>
          <Text fw="500">{patent.title}</Text>
          <ReclaimableAuthorList
            authors={patent.authors}
            onReclaim={authorId => onReclaimAuthorship({ authorId, patentId: patent.id })}
          />
        </Stack>
      )}
    </Modal>
  );
}
